import { Component, OnInit } from '@angular/core';
import {EVOSegmentedControlItem} from '../../../../../shared/reusable-controls/evo-segmented-control/evo-segmented-control.component';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AdminSchoolService} from '../../../../../services/admin/admin-school.service';
import {GroupModel} from '../../../../../models/school/group.model';

@Component({
  selector: 'app-evo-admin-school-group-detail',
  templateUrl: './evo-admin-school-group-detail.component.html',
  styleUrls: ['./evo-admin-school-group-detail.component.css']
})
export class EvoAdminSchoolGroupDetailComponent implements OnInit {

  controls: EVOSegmentedControlItem[] = [
    new EVOSegmentedControlItem('activity', 'Activity'),
    new EVOSegmentedControlItem('student', 'Student')
  ];

  currentItem = this.controls[0];

  group = new GroupModel();

  constructor(private router: Router,
              private route: ActivatedRoute,
              private schoolSv: AdminSchoolService) { }

  ngOnInit() {

    this.route.params.subscribe((params: Params) => {

      const groupId = params.groupId;
      const schoolId = params.schoolId;

      this.schoolSv.fetchGroupById(schoolId, groupId).subscribe((group) => {

        this.group = group;

      });

    });

  }

  onSegmentClicked(segment: EVOSegmentedControlItem) {

    this.router.navigate(['admin', 'schools', this.group.schoolId, 'groups', this.group._id, segment.key]);

  }

  onClose() {
    this.router.navigate(['admin', 'schools', this.group.schoolId, 'detail', 'groups']);
  }

}
